import IPaginatedParams from '@models/paginated-params';
import axiosClient from '@services/axiosClient';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';
import INotificationsPaginatedResponse from '../models/dto/notifications-reponse.dto';
import GetNotificationsDto from '../models/get-notifications.dto';
import IUserNotificationsPreferencesResponse from '../models/get-user-notifications-preferences.dto';
import DisableNotifications from '../models/disable-notifications.dto';

export const getNotifications = async (
  paginatedParams: IPaginatedParams,
  userId: string,
): Promise<
  AxiosResponse<INotificationsPaginatedResponse<GetNotificationsDto>>
> => {
  return await axiosClient.get(
    EndPoints.notifications.getAll(paginatedParams, userId),
  );
};

export const markAsReadByNotificationId = async (
  userId: string,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(
    EndPoints.notifications.makeAsReadByNotificationId(userId),
  );
};

export const getUserNotificationsCommunication = async (
  userId: string | undefined,
): Promise<AxiosResponse<IUserNotificationsPreferencesResponse>> => {
  return await axiosClient.get(
    EndPoints.notifications.getUserNotifications(userId),
  );
};

export const disableNotificationByUserId = async (
  userId: string | undefined,
  payload: DisableNotifications,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(
    EndPoints.notifications.disableNotification(userId),
    payload,
  );
};

export const markAllAsReadByUserId = async (
  userId: string | undefined,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(
    EndPoints.notifications.makeAllAsReadByUserId(userId),
  );
};
